import { render, staticRenderFns } from "./BulkNotificationEdit.vue?vue&type=template&id=9df6f54c&scoped=true&"
import script from "./BulkNotificationEdit.vue?vue&type=script&lang=js&"
export * from "./BulkNotificationEdit.vue?vue&type=script&lang=js&"
import style0 from "./BulkNotificationEdit.vue?vue&type=style&index=0&id=9df6f54c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9df6f54c",
  null
  
)

export default component.exports